var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.858,
    height: 14.858,
    viewBox: "0 0 14.858 14.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#768092;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.434,10.5l-3.25-1.393a.7.7,0,0,0-.813.2L8.932,11.065A10.756,10.756,0,0,1,3.79,5.923L5.549,4.484a.7.7,0,0,0,.2-.813L4.356.421a.7.7,0,0,0-.8-.4L.54.714A.7.7,0,0,0,0,1.393,13.464,13.464,0,0,0,13.465,14.858a.7.7,0,0,0,.679-.54l.7-3.018a.7.7,0,0,0-.407-.8Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.886e71e22f0f831d6dc183280433801b.svg";
export { ForwardRef as ReactComponent };